module.exports = " <div class=\"backdrop visible\" :class=\"{'active': state == 1}\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/services/backdrop/Backdrop.vue
// module id = 247
// module chunks = 0